import { render } from "./Carousel.vue?vue&type=template&id=daea1908&scoped=true&bindings={\"cssClass\":\"props\",\"images\":\"data\",\"imgIndex\":\"data\",\"imgName\":\"data\",\"changeImage\":\"options\",\"startTimer\":\"options\"}"
import script from "./Carousel.vue?vue&type=script&lang=js"
export * from "./Carousel.vue?vue&type=script&lang=js"

import "./Carousel.vue?vue&type=style&index=0&id=daea1908&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-daea1908"

export default script